<template>
  <v-layout align-center justify-center row fill-height>
    <v-container grid-list-xs>
      <v-flex xs12>
        <p class="headline text-xs-center">404 - De pagina kon niet gevonden worden</p>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <v-btn class="primary" :to="{name:'home'}">Ga terug</v-btn>
      </v-flex>
    </v-container>
  </v-layout>
</template>

<script>
export default {};
</script>

<style lang="scss">
</style>
